export const DATA_VIEW_SHOT_HEADER_HEIGHT_PX = 34;
export const DATA_VIEW_MIN_VIDEO_HEIGHT_PX = 230;
export const DATA_VIEW_EMBEDDED_CONTROLS_HEIGHT_PX = 80;
export const DATA_VIEW_DIVIDER_HEIGHT_PX = 8;
export const DATA_VIEW_MAX_VIDEO_OFFSET_PX = 20;
export const DATA_VIEW_MIN_TABLE_HEIGHT_PX = 150;

export const DATA_VIEW_MIN_PLAYER_WRAPPER_HEIGHT_PX =
  DATA_VIEW_MIN_VIDEO_HEIGHT_PX + DATA_VIEW_EMBEDDED_CONTROLS_HEIGHT_PX;

export const getMaxVideoHeightPx = (rightColHeightPx) =>
  Math.max(
    DATA_VIEW_MIN_VIDEO_HEIGHT_PX,
    rightColHeightPx - DATA_VIEW_MAX_VIDEO_OFFSET_PX,
  );

export const getMaxPlayerWrapperHeightPx = (rightColHeightPx) =>
  getMaxVideoHeightPx(rightColHeightPx) + DATA_VIEW_EMBEDDED_CONTROLS_HEIGHT_PX;

export const clampPlayerWrapperHeightPx = (
  wrapperHeightPx,
  rightColHeightPx,
) => {
  const min = DATA_VIEW_MIN_PLAYER_WRAPPER_HEIGHT_PX;
  const max = getMaxPlayerWrapperHeightPx(rightColHeightPx);
  return Math.min(max, Math.max(min, Math.round(wrapperHeightPx)));
};

export const getDefaultPlayerWrapperHeightPx = (
  _leftColHeightPx,
  rightColHeightPx,
) =>
  clampPlayerWrapperHeightPx(
    DATA_VIEW_MIN_PLAYER_WRAPPER_HEIGHT_PX,
    rightColHeightPx,
  );
